import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Autocomplete, Button, Table, TableBody, TableCell, TableContainer, TableRow, TextField } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import { truncate } from "data/data";
import { getCompanyInfoAll } from "components/axios/joinAxios";

const JoinCheckPage = ({setCompany, setCompanyCheck}) => {
    const { t } = useTranslation();

    // modal 관련
    const { openModal } = useModals();
    const handleAlertClick = (alertMessage) => {
        openModal(modals.alertModal, {
            onClose : () => {
            },
            message: alertMessage,
        });
    };
    
    const { control, register, handleSubmit, reset, formState : {isDirty, errors } } = useForm({});
    const [companies, setCompanies] = useState([]);

    useEffect(()=> {
        const fetchCompanies = async () => {
            try {
                const res = await getCompanyInfoAll();
                if (res) setCompanies(res);
            } catch (e) {
                console.error(e);
                setCompanies([]);
            }
        };
        fetchCompanies();
    }, []);
   
    // 등록
    const onSubmit = (data) => {
        // console.log(data)
        setCompanyCheck(true);
        setCompany(data.info)
    };

    return (
        <>
            <div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <TableContainer>
                    <Table sx={{ minWidth: 1000 }} aria-label="simple table" className="same_width" style={{borderTop:"2px solid #a2a2a2"}} >
                        <TableBody>
                        <TableRow>
                            <TableCell className="th" style={{width:"130px"}}>{t('message.common.subtitle.company.name')}</TableCell>
                            <TableCell colSpan={3} style={{textAlign: "left"}}>
                                <Controller
                                name="info"
                                control={control}
                                defaultValue={null}   // ✅ undefined 방지
                                rules={{ 
                                    required: t('message.common.error.text.company.name.input'),
                                }}
                                render={({ field, fieldState }) => (
                                    <Autocomplete
                                    {...field}
                                    value={field.value || null}   // ✅ 항상 null 또는 객체
                                    freeSolo
                                    options={companies ?? []}
                                    getOptionLabel={(option) => {
                                        if (!option) return "";
                                        if (typeof option === "string") return option;               // freeSolo 입력값
                                        if (option.inputValue) return option.inputValue;             // 새 값 추가 처리
                                        return `${option.name}${option.address ? `, ${truncate(option?.address ?? "", 20)}` : ""}`;
                                    }}
                                    onChange={(event, value) => {
                                        // value가 객체면 기존 업체 선택, 문자열이면 새 업체 등록
                                        if (typeof value === "string") {
                                            field.onChange({ id: null, name: value, address: "" }); // 새 업체명
                                        } else if (value && value.inputValue) {
                                        // createOption 패턴 (입력값 기반 새 객체)
                                            field.onChange({ id: null, name: value.inputValue, address: "" });
                                        } else {
                                            field.onChange(value); // 기존 객체
                                        }
                                    }}
                                    onInputChange={(_, newInputValue, reason) => {
                                        if (reason === "input") {
                                            field.onChange({id:null, name:newInputValue}); // 타이핑 값도 그대로 저장
                                            // field.onChange(newInputValue); // 타이핑 값도 그대로 저장
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                        {...params}
                                        label={t('message.common.text.search.company.name')}
                                        error={!!fieldState.error}
                                        />
                                    )}
                                    />
                                )}
                                />
                                {errors.info && <small role="alert"><br></br>{errors.info.message}</small>}
                                {/* <TextField id="businessRegNo" 
                                aria-invalid={!isDirty ? undefined : errors.businessRegNo ? "true" : "false"}
                                {...register("businessRegNo", {
                                    required : t('message.common.error.text.business.register.no.input'),
                                    validate: (value) =>
                                        isValidBizNo(value) || t('message.common.alert.business.register.no.invalid'),
                                })} 
                                // onChange={(e)=>setBusinessRegNo(e.target.value)}
                                sx={{ m: 1, minWidth: '90%' }}
                                error={!!errors.businessRegNo}
                                />
                                {errors.businessRegNo && <small role="alert"><br></br>{errors.businessRegNo.message}</small>} */}
                            </TableCell>
                        </TableRow>
                        </TableBody>
                    </Table>
                    </TableContainer>
                </form>

                <div style={{marginTop:"10px",display: "flex",justifyContent: "space-between",}}>
                    <div>
                        <Link to={'/auth/login'}><Button variant="contained" color="primary" style={{backgroundColor:"#333"}}>{t('message.common.btn.return')}</Button></Link>
                    </div>
                    <div>
                        <Button variant="contained" color="primary" onClick={handleSubmit(onSubmit)}>{t('message.common.btn.confirm')}</Button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default JoinCheckPage;